


























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
/* 画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
/* ストア、定数関連 */
import axios from 'axios';
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import router from '../../router';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { loadingControlModule } from '../../store/modules/LoadingControl';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class DetoxFileInfo extends ApiAccessBase {
  // axiosの共通設定
  protected axiosApi = axios.create();
  // 検索結果ヘッダの設定
  private headers = [{}];
  // 共通パス
  private appAath = Constants.KANRI_URL + '/application/' + applicationFormModule.GET_APP_TYPE + '/detoxfile/' + applicationFormModule.GET_PROCESS_TYPE;
  // 画面更新可否
  private isUpdate: boolean = true;
  // 無害化指示可否
  private isRequestDetox: boolean = false;
  // 無害化キャンセル可否
  private isCancelDetox: boolean = false;
  // 無害化ステータス
  private detoxStatus: string = '';
  // 無害化指示日時
  private requestTime: string = '';
  // 無害化メッセージ
  private detoxMessage: string = '';
  // 無害化開始日時
  private detoxStartTime: string = '';
  // 無害化終了日時
  private detoxEndTime: string = '';
  // 無害化処理結果
  private detoxRemarks: string = '';
  // zipダウンロード可否
  private isZipDownload: boolean = false;
  // アップロード可否
  private isFileUpload: boolean = false;
  // パネル設定
  private exPanel: number[] = [];

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '添付ファイル管理';
    this.screenRemarks = '※この画面では必須チェックは行われませんが、必須マーク付きのファイルは提出時に必須となります。';
    if (supervisingModule.GET_MODE === ScreenMode.READ) {
      this.isUpdate = false;
      this.exPanel = [0, 1];
    } else {
      this.exPanel = [0, 1, 2];
    }
    // ファイルアップロード 可変項目取得
    this.apiAccess(this.appAath + '/init', Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          //検索結果.ボタンの設定
          this.headers.shift(); //先頭の空白列削除
          this.headers.push(
          {text: 'ダウンロード', align: 'center', sortable: false, value: 'edit', width: 90},
          {text: '削除', align: 'center', sortable: false, value: 'delete', width: 90},
          );
          //検索結果.DBから展開
          for (const item of this.variablecols['fileDownload'] ) {
            this.headers.push({text: item.label, align: item.align, sortable: item.sortable, value: item.name, width: item.width,
                              } );
          }
          this.headers.push(
          {text: '無害化ファイル削除', align: 'center', sortable: false, value: 'deleteDetox', width: 90},
          );
          this.getNew();
        }
      },
    );
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['fileUpload', 'fileDownload']);
  }
  /**
   * 無害化状況取得
   */
  private getStatus() {
    loadingControlModule.startLoading();
    axios.get(this.appAath + '/status/' + applicationFormModule.GET_TRADER_ID)
    .then((response) => {
      this.isRequestDetox = response.data.requestDetox;
      this.isCancelDetox = response.data.cancelDetox;
      this.isZipDownload = response.data.zipDownload;
      this.isFileUpload = response.data.upload;
      this.detoxStatus = response.data.statusValue;
      this.requestTime = response.data.updateTime;
      this.detoxMessage = response.data.message;
      this.detoxStartTime = response.data.jobStartTime;
      this.detoxEndTime = response.data.jobEndTime;
      this.detoxRemarks = response.data.remarks;
    }).catch((error) => {
      this.errorMessage += error.response.data.code + ':' + error.response.data.message + '\n';
    }).finally(() => {
      loadingControlModule.endLoading();
    });
  }
  /**
   * 最新情報取得
   */
  private getNew() {
    this.apiAccess(this.appAath + '/list/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, false, true);
    this.getStatus();
  }

　/**
　　* ファイルアップロード
　　*/
  private upload() {
    const formData2 = new FormData();
    let isUpload: boolean = false;
    // ファイル件数取得
    for (const col of Object.keys(this.variablecols['fileUpload'])) {
      if (this.variablecols['fileUpload'][col].modelValue instanceof File) {
        isUpload = true;
        break;
      }
    }
    // 登録しようとしているファイルが0件の場合
    if (!isUpload) {
      window.alert('アップロード対象のファイルが存在しません。');
      return;
    }

    if (window.confirm(Message.I0003)) {
      loadingControlModule.startLoading();
      // formデータの加工
      for (const col of Object.keys(this.variablecols['fileUpload'])) {
        if (this.variablecols['fileUpload'][col].modelValue instanceof File) {
          formData2.append('files', this.variablecols['fileUpload'][col].modelValue);
          formData2.append('names', this.variablecols['fileUpload'][col].name);
        }
      }

      const config = {
          headers: {
              'content-type': 'multipart/form-data',
          },
      };
      this.errorMessage = '';
      this.infoMessage = '';
      this.warnMessage = '';
      axios
        .post(this.appAath + '/upload/' + applicationFormModule.GET_TRADER_ID, formData2, config)
        .then((response) => {
          // メッセージの設定 template start
          if (response.data.resultMessages && response.data.resultMessages.notEmpty) {
            this.resultMessagesList = response.data.resultMessages.list;
            // const isErrorMessage = response.data.resultMessages.type === 'ERROR' ? true : false;
            for (const messageIndex of Object.keys(this.resultMessagesList)) {
              // const tempMessage = this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
              // if (isErrorMessage) {
                // this.errorMessage += tempMessage;
              // } else {
                // this.infoMessage += tempMessage;
              // }
              this.infoMessage += this.resultMessagesList[Number(messageIndex)].code + ':' + this.resultMessagesList[Number(messageIndex)].text + '\n';
            }
          }
          // メッセージの設定 template end
            // 成功
          // alert(Message.I0004);
          //再検索前に登録成功メッセージ保持
          const successMessage = this.infoMessage;
          //ファイル一覧再検索
          this.getNew();
          //再検索後に登録成功メッセージ格納
          this.infoMessage = successMessage;
        })
        .catch((error) => {
            // 失敗
          this.errorMessage = error.response.data.code + ':' + error.response.data.message + '\n';
          })
        .finally(() => {
          loadingControlModule.endLoading();
        });
      // メッセージ表示位置へ移動
      this.hrefElement('detoxFileInfo', -50);
    }
  }

  /**
　  * ファイルダウンロード
　  */
  private download(param: string) {
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      this.apiAccessDownload(this.appAath + '/download' + '/' + applicationFormModule.GET_TRADER_ID + '/' + param);
    }
  }

  /**
　  * ファイル一括ダウンロード
　  */
  private zip() {
    // ボタン押下時
    if (window.confirm(Message.I0033)) {
      this.apiAccessDownload(this.appAath + '/downloadall/' + applicationFormModule.GET_TRADER_ID);
    }
  }

  /**
　  * ファイル削除
　  */
  private deleteFile(param: string) {
    for (const listNo of Object.keys(this.variablecols['fileUpload'])) {
      const fileid =  this.variablecols['fileUpload'][listNo].internalId;
      if (fileid === param) {
        if (this.variablecols['fileUpload'][listNo].required) { //必須項目の場合ファイル削除前に確認メッセージ表示
          if (!window.confirm(Message.I0023)) {
            return;
          }
        }
      }
    }
    // ボタン押下時
    this.postDelete(this.appAath + '/delete/' + applicationFormModule.GET_TRADER_ID + '/' + param);
  }

  /**
   * 無害化ファイル削除
   */
  private deleteDetox(param: string) {
    this.postDelete(this.appAath + '/deletedetox/' + applicationFormModule.GET_TRADER_ID + '/' + param);
  }
  /**
   * 削除（共通）
   */
  private postDelete(path: string) {
    // ボタン押下時
    if (window.confirm(Message.I0029)) {
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, null, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          // 成功
          // 再検索前に削除成功メッセージ保持
          const deleteMessage = this.infoMessage;
          // ファイル一覧再検索
          //this.apiAccess(this.appAath + '/list/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, true, true);
          this.getNew();
          // 再検索後に削除成功メッセージ格納
          this.infoMessage = deleteMessage;
        } else {
          // 失敗
        }
      });
      // メッセージ表示位置へ移動
      this.hrefElement('detoxFileInfo', -50);
    }
  }

  private detoxRequest() {
    this.postDetox(this.appAath + '/detoxrequest/' + applicationFormModule.GET_TRADER_ID, '無害化指示を行ってよろしいですか。');
  }
  private detoxCancel() {
    this.postDetox(this.appAath + '/detoxcancel/' + applicationFormModule.GET_TRADER_ID, '無害化指示のキャンセルを行ってよろしいですか。');
  }
  /**
   * 無害化指示（共通）
   */
  private postDetox(path: string, message: string) {
    // ボタン押下時
    if (window.confirm(message)) {
      if (this.isUpdate) {
        // アップロード欄非表示
        this.exPanel = [1, 2];
      }
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, null, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //メッセージ退避
          const tempMessage = this.infoMessage;
          // 成功
          this.getNew();
          //メッセージ再設定
          this.infoMessage = tempMessage;
        } else {
          // 失敗
        }
      });
      // メッセージ表示位置へ移動
      this.hrefElement('detoxFileInfo', -50);
    }
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    router.push('appForm');
  }
}
